import axios from "../../config/axiosConfig";
import {
  CREATE_ORDER_DELIVERY_SCHEDULE, 
  UPDATE_ORDER_DELIVERY_SCHEDULE,
  DELETE_ORDER_DELIVERY_SCHEDULE,
  ORDER_DELIVERY_SCHEDULE_REQUEST,
  ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS,
  ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE,
} from "../types/order-delivery-schedule-types";

export const getOrderDeliveryScheduleById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST });
    
      const { auth } = getState();

      return axios.get(`/order-delivery-schedule/get/${id}`, {
          params: {
            companyId: auth.company?.id
          }
        }).then((response) => {
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createOrderDeliverySchedule = (orderDeliverySchedule) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST });
      const newOrderDeliverySchedule = {
        ...orderDeliverySchedule
      };
      return axios.post("/order-delivery-schedule/add", newOrderDeliverySchedule,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_ORDER_DELIVERY_SCHEDULE, payload: response.data });
        } else {
          dispatch({
            type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE,
            error: "Order delivery schedule create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateOrderDeliverySchedule = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST });
      const { auth } = getState();
      return axios.put("/order-delivery-schedule/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_ORDER_DELIVERY_SCHEDULE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE,
            error: "Order delivery schedule update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteOrderDeliverySchedule = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST });
      return axios.delete(`/order-delivery-schedule/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_ORDER_DELIVERY_SCHEDULE, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};